module.exports = __webpack_public_path__ + "img/ic_arrow_right_white.1b720bca.svg";